import styles from './AboutPage.module.css';

function AboutPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.pageHeading}>About</h1>
      <p>Learn more about Nautorious Yacht Charters.</p>
    </div>
  );
}

export default AboutPage;
